export default[
    {
        number:1,
        title:"Paws Down, the Best Hosting!",
        picImg:"pexels-dids-2127433.jpg", 
        para:"As a feline influencer, my website's performance is crucial. This hosting company has been purr-fectly reliable! No more 'cat-astrophic' downtime. Highly recommended!",  
        name:"Paws"  
            },
    {
        number:2,
        title:"Feline-Friendly Hosting at Its Finest!",
        picImg:"pexels-amber-janssens-6897077.jpg", 
        para:"I may have whiskers, but I've got high standards for hosting. This company's services are as smooth as my fur. My website is always online and lightning-fast!",  
        name:"Whiskers"  
            },
    {
        number:3,
        title:"Cat-tastic Support and Service!",
        picImg:"pexels-alena-koval-982300.jpg", 
        para:"Whenever I've had a question, the support team at this hosting company has been as friendly as a playful kitten. Their assistance is truly 'purr-fect' and their servers are as dependable as my nap times!",  
        name:"Luna"  
        },
    {   
        number:4,
        title:"Catpreneur's Choice!",
        picImg:"pexels-pelageia-zelenina-9594607.jpg", 
        para:"Fluffy here, and I run a 'cat-tastic' online store. This hosting company's e-commerce solutions are the cat's meow. My sales have soared, and I'm as content as a cat in a sunbeam!",  
        name:"Fluffy"  
    },
     {
        number:5,
        title:"Unfur-gettable Hosting Experience!",
        picImg:"pexels-arina-krasnikova-7725611.jpg", 
        para:"I like my hosting black and white—no gray areas. This hosting company delivers! My website is so sleek, it's like a tuxedo for the internet. Highly recommended by this tuxedo cat!",  
        name:"Oreo"  
            },
    {
        number:6,
        title:"The Catnip of Hosting!",
        picImg:"pexels-just-a-couple-photos-3777622.jpg", 
        para:"I've explored other hosting options, but this one is like catnip to me. My website's popularity has soared, and I'm one happy kitty!",  
        name:"Mittens"  
            },   
    {
        number:7,
        title:"Paw-some Security!",
        picImg:"pexels-pixabay-45201.jpg", 
        para:"Security is a top priority, and this hosting company keeps my website safe and sound. I can sleep like a contented cat, knowing my data is secure.",  
        name:"Bella"  
            },                        
]
